import { ModuleAdminPage } from "./ModuleAdminPage";
export function AdminGraduateWeekPage() { return <ModuleAdminPage title="畢業首週" code="graduate-week" text="依 graduation_at 起算 7 天，不全站重算。" />; }
